import { render, staticRenderFns } from "./add-mail-modal.vue?vue&type=template&id=2c8a339c&"
import script from "./add-mail-modal.vue?vue&type=script&lang=js&"
export * from "./add-mail-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-mail-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports